import { render, staticRenderFns } from "./AggregatesOrder.vue?vue&type=template&id=0f94363e&scoped=true"
import script from "./AggregatesOrder.vue?vue&type=script&lang=js"
export * from "./AggregatesOrder.vue?vue&type=script&lang=js"
import style0 from "./AggregatesOrder.vue?vue&type=style&index=0&id=0f94363e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f94363e",
  null
  
)

export default component.exports